import { motion } from "framer-motion";
import { Mail } from "lucide-react";
import { BackButton } from "./ui/BackButton";

interface NewsletterArchiveProps {
  onBack: () => void;
}

export const NewsletterArchive = ({ onBack }: NewsletterArchiveProps) => {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="sticky top-0 z-10 bg-background/95 backdrop-blur-sm border-b border-border">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <BackButton onClick={onBack} label="Back" srLabel="Return to cover page" />
          
          <div className="flex items-center gap-2 text-muted-foreground">
            <Mail className="w-4 h-4" />
            <span className="text-xs uppercase tracking-[0.15em]">Newsletter</span>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="space-y-8"
        >
          {/* Title Section */}
          <header className="text-center space-y-4">
            <h1 className="font-display text-3xl md:text-4xl text-foreground">
              Read the Newsletter
            </h1>
            <p className="text-muted-foreground max-w-lg mx-auto">
              Explore our archive of past newsletters filled with spiritual reflections, 
              reminders, and guidance for your journey.
            </p>
            <div className="flex justify-center">
              <div className="w-16 h-px bg-gold" />
            </div>
          </header>

          {/* Mailchimp Embed */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.6 }}
            className="bg-card rounded-lg overflow-hidden shadow-page border border-border"
          >
            <iframe
              src="https://us22.campaign-archive.com/home/?u=5a9632923e511cde020ea691f&id=2c84ddabaa"
              className="w-full h-[800px] md:h-[900px] border-0"
              loading="lazy"
              title="Newsletter Archive"
            />
          </motion.div>
        </motion.div>
      </main>
    </div>
  );
};
